<template>
    <div class="index">
        <Header></Header>
        <div class="introduce">
            <div class="wrap">
                <div class="sunshine_content" id="sunshine_content">
                    <div id="UIFrame_202855" style="display: block;">
                        <div class="content_title">
                            <h3>书目下载</h3>
                            <p class="crumbs">
                                当前位置：
                                <router-link :to="{ path: '/' }">
                                    <i class="home"></i>
                                    首页
                                </router-link>
                                &gt;
                                <a href="#">景初书目</a>
                            </p>
                        </div>
                        <table class="book_table" style="width: 80%;text-align: center;height: 800px;">
                            <thead>
                                <tr class="table_title">
                                    <th>书目标题</th>
                                    <th>期数</th>
                                    <th>创建时间</th>
                                    <th>操作</th>
                                </tr>
                            </thead>

                            <tbody id="bookTable">
                                <tr class="bookTable" v-for="item in tableData">
                                    <td class="time02" style="width: 200px;"><i></i>{{ item.listTitle }}</td>
                                    <td class="time01" > <em>{{ item.listPeriods }}</em>期</td>
                                    <td class="time01"><b>{{ item.createDate }}</b></td>
                                    <td class="time01" ><a href="javascript:;" class="jsDownloadbib" @click="upload(item)">下载</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Axios from "@/api/diyaxios";
export default {
    data() {
        return {
            tableData: [],
            pageNum: 1,
            pageSize: 10,
        };
    },
    components: {
        Header,
        Footer
    },
    created() {
        this.changeList('2018020915511601905')
        // let a = '三新采访2328期（社科1663条）'
        // const parameter1='三新';
        // const parameter2='景初';
        // const tstring = a.replace(parameter1,parameter2);
        // console.log(tstring);
    },
    methods: {
        changeList(gid) {
            let vm = this;
            Axios.post('/whgs/api/queryhbjingchubycondition', {
                params: {
                    groupid: gid,
                    pageNum: 1,
                    pageSize: 100000,
                }
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                vm.tableData = res.result.data;
            }).catch((err) => {
                console.log(err);
            });
        },
        goDatail() {
            this.$router.push({ name: 'download' })
        },
        upload(item) {
            let vm = this;
            window.open('http://ytzhihui.com' + item.attachUrl)
        },
    }
}
</script>

<style lang="scss" scoped>
.introduce {
    margin-top: 30px;
}

.sunshine_nav {
    width: 202px;
    float: left;
}

.sunshine_content {
    float: right;
    width: 1200px;
}

.content_title {
    height: 64px;
    border-bottom: 1px solid #DFE3E5;
    line-height: 64px;
}

.content_title h3 {
    font-size: 24px;
    color: #3089e9;
    display: inline-block;
    float: left;
}

.content_title .crumbs {
    font-size: 14px;
    color: #666;
    display: inline-block;
    float: right;
}

.banner_box {
    height: 350px;
    width: 100%;
    /* background: url(../images/banner.png) no-repeat; */
    position: relative;
    z-index: 4;
}

.banner_box {
    height: 350px;
    width: 100%;
    /* background: url(../images/banner.png) no-repeat; */
    position: relative;
    z-index: 4;
}</style>


// WEBPACK FOOTER //
// src/views/download.vue